export default "__VITE_ASSET__f88c434a__"